// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3dKN0","imageUploader":"EGiftCard_imageUploader__2HBnl"};